import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { round2 } from 'src/app/helpers/math-helper';

@Component({
    selector: 'app-percentage-split',
    templateUrl: './percentage-split.component.html',
    styleUrls: ['./percentage-split.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PercentageSplitComponent {
  @Input() label = 'Andel (%)';
  @Input() percent = 0;
  @Input() absolute = 0;
  @Input() suffix = 'kr.';
  @Input() disabled = false;
  @Input() maxPercent = 1;

  @Output() percentChange = new EventEmitter<number>();

  onPercentChange(value: any) {
    let v = Number(value);
    if (isNaN(v)) v = 0;
    v = round2(Math.max(0, Math.min(100, v)));
    this.percent = v;
    this.percentChange.emit(v);
  }

  round2(value: number): number {
    return round2(value);
  }
}
